/**
 * Available wizard field options for mapping document properties
 * to contract wizard form fields.
 */
export const WIZARD_FIELD_OPTIONS = [
  { value: '', label: '-- Not mapped --' },
  { value: 'title', label: 'Contract Title' },
  { value: 'referenceNumber', label: 'Reference Number' },
  { value: 'description', label: 'Description' },
  { value: 'parties.customer.name', label: 'Customer Name' },
  { value: 'parties.customer.abn', label: 'Customer ABN' },
  // Wire values keep the 'contractor' role key (backend contract shape);
  // labels use the app-wide 'Supplier' display term.
  { value: 'parties.contractor.name', label: 'Supplier Name' },
  { value: 'parties.contractor.abn', label: 'Supplier ABN' },
] as const;
